export const checkoutUrl = 'https://sistema-situacion-actual-en-orden.impultienda.ar/checkout'

export const stats: readonly (readonly [string, string])[] = [
  ['+380', 'madres usando el sistema'],
  ['3', 'Volúmenes completos'],
  ['5', 'Bonos incluidos'],
  ['4.9/5', 'calificación'],
]

export const testimonials: readonly (readonly [string, string, string, string])[] = [
  ['VS', 'Valeria S.', 'Buenos Aires', 'Finalmente tengo claro dónde estoy parada. No reviso carpetas viejas cada vez que necesito información. Mi cabeza descansa.'],
  ['RH', 'Romina H.', 'Mendoza', 'La síntesis de una página es genial. Antes usaba tres carpetas diferentes. Ahora consulto una sola referencia.'],
  ['DF', 'Daniela F.', 'Córdoba', 'No pensé que ordenar información me quitaría tanta ansiedad. Siento que recuperé el control de lo que sé sobre mi hijo.'],
  ['CN', 'Cecilia N.', 'Rosario', 'Separo lo actual de lo viejo fácil. El método funciona. Finalmente respiro cuando abro una carpeta.'],
]

export const extendedTestimonials: readonly (readonly [string, string, string])[] = [
  ['Laura M.', 'Buenos Aires', '“Pasé de tener carpetas en todos lados a una síntesis que consulto cada día. El método del Punto de Corte cambió todo.”'],
  ['Soledad B.', 'La Plata', '“No sabía que era tan fácil separar lo actual de lo viejo. Ahora uso el Registro de Novedades y mi síntesis se mantiene sola.”'],
  ['Jimena P.', 'Rosario', '“El Banco de Pendientes fue lo mejor. Antes cargaba con dudas todo el tiempo. Ahora las ordeno en un lugar y dejo de pensar.”'],
  ['Martina T.', 'Córdoba', '“Con la Ficha Única de Síntesis hice todo en 14 días. Pasé de estar desesperada a tener una referencia clara que me salva tiempo.”'],
  ['Carolina S.', 'San Juan', '“Pensé que necesitaba más volúmenes. Estos 3 van al punto. Cada uno resuelve una parte diferente. Genial el sistema.”'],
]

export const painPoints: readonly string[] = [
  'Demasiada información acumulada durante años.',
  'Confundir lo actual con lo viejo.',
  'Tener que revisar múltiples fuentes para encontrar una respuesta.',
  'Sentir que podés estar perdiéndote algo importante.',
  'Sentirte siempre desprevenida frente a la información.',
]

export const volumes: readonly (readonly [string, readonly string[], string])[] = [
  [
    'Volumen 1 — Fundamentos para Identificar la Información Actual™',
    [
      'Diferenciás lo que corresponde al presente de lo que quedó atrás',
      'Aplicás el Punto de Corte Temporal para empezar sin abrumarte',
      'Separás información repetida y dudosa del resto',
      'Creás tu primer Inventario de Información Actual™',
      'Te tranquilizás sabiendo qué información tenés identificada',
    ],
    'border-blue-400/30',
  ],
  [
    'Volumen 2 — Principios para Construir una Síntesis Actual™',
    [
      'Transformás información dispersa en una referencia clara de una página',
      'Usás la Matriz de Situación Actual™ para reunir todo en un lugar',
      'Resumís sin interpretar, solo organizás lo que existe',
      'Conservás las fuentes para volver cuando necesites verificar',
      'Consultás tu síntesis sin tener que buscar en múltiples carpetas',
    ],
    'border-green-400/30',
  ],
  [
    'Volumen 3 — Claves para Mantener una Visión Actualizada™',
    [
      'Incorporás novedades sin que tu síntesis se desordene',
      'Usás la rutina de mantenimiento de forma sostenible',
      'Evitás reconstruir todo desde cero cuando llega información nueva',
      'Llevás registro de qué cambió y cuándo',
      'Tu referencia siempre está actualizada y vigente',
    ],
    'border-amber-400/30',
  ],
]

export const includes: readonly string[] = [
  'Síntesis de una página lista para consultar',
  'Implementación guiada de 14 días, 15 minutos por día',
  'Plantillas imprimibles para cada etapa',
  'Rutina de mantenimiento para no volver al caos',
]

export const bonuses: readonly (readonly [string, string, readonly string[], string])[] = [
  ['01', 'Mapa Express de Información Actual™', ['Ubicás en 15 minutos qué información es del “ahora” sin abrumarte', 'Separás visualmente lo actual de lo anterior', 'Tenés un mapa imprimible para trabajar con rapidez', 'Conseguís claridad inmediata sobre tu período actual'], '$12.000'],
  ['02', 'Ficha Única de Síntesis Rápida™', ['Reunís lo importante en una sola página consultable', 'Tenés una plantilla que completás en minutos', 'Dejás de buscar información en diez lugares distintos', 'Tu referencia está siempre lista a mano'], '$10.000'],
  ['03', 'Etiquetas de Fecha y Fuente™', ['Marcás cada documento, foto y captura con contexto claro', 'Recordás de cuándo es cada cosa sin confundirte', 'Identificás la fuente original de cualquier dato', 'Evitás perder papeles o archivos otra vez'], '$9.000'],
  ['04', 'Registro de Novedades Actuales™', ['Anotás información nueva en menos de 3 minutos', 'Incorporás cambios sin que todo se desordene', 'Mantenés tu síntesis actualizada con una rutina simple', 'No reconstruís nada desde cero cuando llega novedad'], '$11.000'],
  ['05', 'Banco de Pendientes sin Interpretar™', ['Separás lo dudoso de tu síntesis clara sin tirar nada', 'Sacás de tu cabeza información incompleta', 'Bajás la ansiedad ordenando las dudas en un lugar', 'Recuperás tranquilidad mental organizando lo pendiente'], '$10.000'],
]

export const faqs: readonly (readonly [string, string])[] = [
  ['¿Necesito saber de medicina para usar el sistema?', 'No. Solo organizás y anotás. El médico interpreta. El sistema es 100% organizativo.'],
  ['¿Cuánto tiempo me toma implementarlo?', 'La implementación está pensada para 14 días, con pequeñas acciones diarias. Podés avanzar dedicando alrededor de 15 minutos por día.'],
  ['¿Cuándo veo resultados?', 'En 14 días podés tener tu síntesis clara y organizada. Después, podés mantenerla actualizada con una rutina breve.'],
  ['¿Es realmente digital 100%?', 'Sí. Acceso inmediato por email en PDF. Leés desde celular, tablet, computadora o imprimís si preferís.'],
  ['¿La garantía es real?', 'Totalmente. Si no te sirve, devolvemos el 100% sin formularios ni preguntas. Punto.'],
  ['¿Reemplaza la consulta médica?', 'No. Es 100% organizativo. Complementa tu seguimiento médico; no lo reemplaza.'],
]

export const costs: readonly string[] = [
  'Otro año más buscando información en lugares diferentes',
  'Papeles perdidos cuando más los necesitás',
  'Reconstruir todo desde cero cada vez que llega novedad',
  'Carga mental de “¿no me estoy olvidando nada?”',
  'Sensación de estar siempre desprevenida frente a la información',
]

export const purchases: readonly (readonly [string, string])[] = [
  ['Valeria S.', 'Buenos Aires'],
  ['Romina H.', 'Mendoza'],
  ['Daniela F.', 'Córdoba'],
  ['Cecilia N.', 'Rosario'],
]
